import React from 'react';
import ReportEditor from '../../reportEditorPage/reportEditor/ReportEditor';

/**
 * PitchEditor
 * Dedicated entry point for Pitch drafts.
 * Reuses the report editor runtime (Yjs/ProseMirror setup) so behavior stays aligned.
 */
export default function PitchEditor() {
    return <ReportEditor />;
}

